var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignuparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 1.1875L14.75 4L11.9375 1.1875ZM14.75 4L11.9375 6.8125L14.75 4ZM14.75 4H1.25H14.75Z",
    fill: "#3CB98A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 1.1875L14.75 4M14.75 4L11.9375 6.8125M14.75 4H1.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignuparrow);
export default __webpack_public_path__ + "static/media/signuparrow.6293bc0301cc3a100312f26b432e9448.svg";
export { ForwardRef as ReactComponent };